import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useVariantsStore } from '../../../store/variants';
export default function Checkbox({ attribute }) {
    const selectedValues = useVariantsStore((state) => state.selectedValues);
    const updateSelectedValue = useVariantsStore((state) => state.updateSelectedValue);
    return (_jsx("div", { className: "attribute-checkbox", children: attribute.values.map((value, i) => {
            const selected = selectedValues.some((selectedValue) => selectedValue.attribute.id === attribute.id && selectedValue.value.id === value.id);
            return (_jsxs("div", { className: "mr-2", children: [_jsx("input", { type: "checkbox", id: `attribute-checkbox-${value.id}`, checked: selected, onChange: () => {
                            if (!selected)
                                updateSelectedValue({ attribute, value });
                        } }), _jsx("label", { htmlFor: `attribute-checkbox-${value.id}`, children: value.value })] }, `attribute-checkbox-${i}`));
        }) }));
}
